export default __webpack_public_path__ + "3b99ab0d8457e0a75247c15a2203786f.png";